import OrderDetailsDialog from '@/components/orders/OrderDetailsDialog.vue'

export default {
  components: {
    OrderDetailsDialog
  },

  mixins: [],

  data() {
    return {
      orderDetailsDialogVisible: false,
      selectedOrder            : null
    }
  },

  created() {
    this.$bus.$on('show-order-details-dialog', this.showOrderDetailsDialog)
    this.$bus.$on('hide-order-details-dialog', this.hideOrderDetailsDialog)
  },

  beforeDestroy() {
    this.$bus.$off('show-order-details-dialog', this.showOrderDetailsDialog)
    this.$bus.$off('hide-order-details-dialog', this.hideOrderDetailsDialog)
  },

  methods: {
    showOrderDetailsDialog(data) {
      this.selectedOrder = data

      this.$nextTick(() => {
        this.orderDetailsDialogVisible = true
      })
    },
    
    hideOrderDetailsDialog() {
      this.orderDetailsDialogVisible = false

      this.$nextTick(() => {
        this.selectedOrder = null
      })
    }
  }
}
